import { Button, Grid, Group, Modal, Text } from '@mantine/core';
import { IconCloudDownload } from '@tabler/icons-react';
import LabeledSlider from '../LabeledSlider';
import { useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../ErrorMessage';

const ProductTrendsExportModal = ({ isOpen, close, scheduled, startDate, endDate, trend }) => {
  const [productsCount, setProductCount] = useState();
  const [exporting, setExporting] = useState();
  const [error, setError] = useState();

  const { accountId, domainId } = useParams();
  const fetchUrl = `/api/admin/accounts/${accountId}/domains/${domainId}/productTrends/exports`;

  const exportProductTrend = () => {
    const requestBody = {
      trend: trend.trend,
      title: trend.title,
      startDate,
      endDate,
      count: productsCount,
    };

    setExporting(true);
    fetch(fetchUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
      .then(() => {
        scheduled();
        setExporting(false);
      })
      .catch((error) => {
        setError(error);
        setExporting(false);
      });
  };

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  return (
    <Modal size="lg" opened={isOpen} onClose={() => close()} title="Export Ranked Products in Trends">
      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
          <label>Max products to export</label>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 8 }}>
          <LabeledSlider min={1} max={100} value={productsCount} onChange={(count) => setProductCount(count)} />
          <Text size="xs" c="dimmed" mt="xs">
            The actual number depends on the number of products that match the selected product trend.
          </Text>
        </Grid.Col>
      </Grid>
      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={() => close()}>
          Close
        </Button>
        <Button disabled={exporting} onClick={exportProductTrend} leftSection={<IconCloudDownload size={16} />}>
          Export
        </Button>
      </Group>
    </Modal>
  );
};

export default ProductTrendsExportModal;
